import ImageCarousel from "./ImageCarousel";

import styles from "./ImageLayoutCarouselLeft.module.css";
import ImageSlot from "./ImageSlot";

interface Props {
    editing?: boolean;
    images: { [key: string | number]: File | string | null };
    onImageChange?: (key: string | number, newImage: File | null) => void;
}

export default function ImageLayoutCarouselLeft({
    editing,
    images,
    onImageChange,
}: Props) {
    return (
        <div className={styles.imageContainer}>
            <ImageCarousel
                images={images}
                editing={editing}
                size={editing ? 4 : undefined}
                onImageChange={onImageChange}
            />
            <ImageSlot
                label="Cover Image"
                image={images.cover}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange("cover", img);
                }}
                editing={editing}
            />
        </div>
    );
}
